import { createAction } from '@reduxjs/toolkit'
import reducer from './reducer'

export const {
  saveFiltersAndSorter,
  setSearch,
  fetchShopsSuccess,
  fetchShopsFailure,
  fetchLocalizedShopsSuccess,
  fetchLocalizedShopsFailure,
  fetchShopImageSetsSuccess,
  fetchShopImageSetsFailure,
  fetchShopCampaignDealsSuccess,
  fetchShopCampaignDealsFailure,
  fetchShopAdPackagesSuccess,
  fetchShopAdPackagesFailure,
  fetchShopOffersSuccess,
  fetchShopOffersFailure,
  fetchShopSeoDescriptionsSuccess,
  fetchShopSeoDescriptionsFailure,
  fetchPartnerOffersSuccess,
  fetchPartnerOffersFailure,
  fetchConquestAdsSuccess,
  fetchConquestAdsFailure,
  fetchShopProgramsSuccess,
  fetchShopProgramsFailure,
  fetchShopsToVerifySuccess,
  fetchShopsToVerifyFailure,
  startSaving,
  finishSaving,
  clearShops,
  clearData,
  removeShopGroup,
  addShopGroup,
  updateShopGroupPosition,
  setShopOfferForEdit,
  setShopImageSetsDeletedSets,
  resetShopImageSets,
} = reducer.actions

export const fetchShops = createAction('shops/fetchShops')
export const fetchLocalizedShops = createAction('shops/fetchLocalizedShops')
export const fetchShopCampaignDeals = createAction(
  'shops/fetchShopCampaignDeals'
)
export const fetchShopAdPackages = createAction('shops/fetchShopAdPackages')
export const fetchShopOffers = createAction('shops/fetchShopOffers')

export const fetchShopPrograms = createAction('shops/fetchShopPrograms')

export const updateShop = createAction('shops/updateShop')
export const updateShopSuccess = createAction('shops/updateShopsSuccess')
export const updateShopFailure = createAction('shops/updateShopFailure')

export const updateLocalizedShop = createAction('shops/updateLocalizedShop')
export const updateLocalizedShopSuccess = createAction(
  'shops/updateLocalizedShopsSuccess'
)
export const updateLocalizedShopFailure = createAction(
  'shops/updateLocalizedShopFailure'
)

export const updateShopCouponsSettings = createAction(
  'shops/updateShopCouponsSettings'
)
export const updateShopCouponsSettingsSuccess = createAction(
  'shops/updateShopCouponsSettingsSuccess'
)
export const updateShopCouponsSettingsFailure = createAction(
  'shops/updateShopCouponsSettingsFailure'
)

export const createShopCampaign = createAction('shops/campaigns/createCampaign')

export const createShopCampaignSuccess = createAction(
  'shops/campaigns/createShopCampaignSuccess'
)

export const createShopCampaignFailure = createAction(
  'shops/campaigns/createShopCampaignFailure'
)

export const updateShopCampaign = createAction(
  'shops/campaigns/updateShopCampaign'
)
export const updateShopCampaignSuccess = createAction(
  'shops/campaigns/updateShopCampaignSuccess'
)
export const updateShopCampaignFailure = createAction(
  'shops/campaigns/updateShopCampaignFailure'
)

export const deleteCampaign = createAction('shops/campaigns/deleteCampaign')
export const deleteCampaignSuccess = createAction(
  'shops/campaigns/deleteCampaignSuccess'
)
export const deleteCampaignFailure = createAction(
  'shops/campaigns/deleteCampaignFailure'
)

export const createShopOffer = createAction('shops/offers/createShopOffer')
export const createShopOfferSuccess = createAction(
  'shops/offers/createShopOfferSuccess'
)
export const createShopOfferFailure = createAction(
  'shops/offers/createShopOfferFailure'
)

export const updateShopOffer = createAction('shops/offers/updateShopOffer')
export const updateShopOfferSuccess = createAction(
  'shops/offers/updateShopOfferSuccess'
)
export const updateShopOfferFailure = createAction(
  'shops/offers/updateShopOfferFailure'
)

export const deleteAdPackage = createAction('shops/adPackages/deleteAdPackage')
export const deleteAdPackageSuccess = createAction(
  'shops/adPackages/deleteAdPackageSuccess'
)
export const deleteAdPackageFailure = createAction(
  'shops/adPackages/deleteAdPackageFailure'
)

export const duplicateAdPackage = createAction(
  'shops/adPackages/duplicateAdPackage'
)
export const duplicateAdPackageSuccess = createAction(
  'shops/adPackages/duplicateAdPackageSuccess'
)
export const duplicateAdPackageFailure = createAction(
  'shops/adPackages/duplicateAdPackageFailure'
)

export const deleteShopOffer = createAction('shops/offers/deleteShopOffer')
export const deleteShopOfferSuccess = createAction(
  'shops/offers/deleteShopOfferSuccess'
)
export const deleteShopOfferFailure = createAction(
  'shops/offers/deleteShopOfferFailure'
)

export const deleteShopAllOffers = createAction('shops/offers/deleteShopAllOffers')
export const deleteShopAllOffersSuccess = createAction(
  'shops/offers/deleteShopAllOffersSuccess'
)
export const deleteShopAllOffersFailure = createAction(
  'shops/offers/deleteShopAllOffersFailure'
)

export const createShopGroup = createAction('shops/groups/createShopGroup')
export const createShopGroupSuccess = createAction(
  'shops/groups/createShopGroupSuccess'
)
export const createShopGroupFailure = createAction(
  'shops/groups/createShopGroupFailure'
)

export const updateShopGroup = createAction('shops/groups/updateShopGroup')
export const updateShopGroupSuccess = createAction(
  'shops/groups/updateShopGroupSuccess'
)
export const updateShopGroupFailure = createAction(
  'shops/groups/updateShopGroupFailure'
)

export const deleteShopGroup = createAction('shops/groups/deleteShopGroup')
export const deleteShopGroupSuccess = createAction(
  'shops/groups/deleteShopGroupSuccess'
)
export const deleteShopGroupFailure = createAction(
  'shops/groups/deleteShopGroupFailure'
)

export const createShopCategory = createAction(
  'shops/categories/createShopCategory'
)
export const createShopCategorySuccess = createAction(
  'shops/categories/createShopCategorySuccess'
)
export const createShopCategoryFailure = createAction(
  'shops/categories/createShopCategoryFailure'
)

export const updateShopCategory = createAction(
  'shops/categories/updateShopCategory'
)
export const updateShopCategorySuccess = createAction(
  'shops/categories/updateShopCategorySuccess'
)
export const updateShopCategoryFailure = createAction(
  'shops/categories/updateShopCategoryFailure'
)

export const deleteShopCategory = createAction(
  'shops/categories/deleteShopCategory'
)
export const deleteShopCategorySuccess = createAction(
  'shops/categories/deleteShopCategorySuccess'
)
export const deleteShopCategoryFailure = createAction(
  'shops/categories/deleteShopCategoryFailure'
)

// Shop image set
export const fetchShopImageSets = createAction('shops/fetchShopImageSets')

export const updateShopImageSets = createAction(
  'shops/imageSet/updateShopImageSets'
)

export const fetchUpdateTagsCount = createAction('shops/fetchUpdateTagsCount')

// Shop SEO Descriptions
export const fetchShopSeoDescriptions = createAction(
  'shops/fetchShopSeoDescriptions'
)

export const createShopSeoDescription = createAction(
  'shops/seoDescriptions/createShopSeoDescription'
)
export const createShopSeoDescriptionSuccess = createAction(
  'shops/seoDescriptions/createShopSeoDescriptionSuccess'
)
export const createShopSeoDescriptionFailure = createAction(
  'shops/seoDescriptions/createShopSeoDescriptionFailure'
)

export const updateShopSeoDescription = createAction(
  'shops/seoDescriptions/updateShopSeoDescription'
)
export const updateShopSeoDescriptionSuccess = createAction(
  'shops/seoDescriptions/updateShopSeoDescriptionSuccess'
)
export const updateShopSeoDescriptionFailure = createAction(
  'shops/seoDescriptions/updateShopSeoDescriptionFailure'
)

export const deleteShopSeoDescription = createAction(
  'shops/seoDescriptions/deleteShopSeoDescription'
)
export const deleteShopSeoDescriptionSuccess = createAction(
  'shops/seoDescriptions/deleteShopSeoDescriptionSuccess'
)
export const deleteShopSeoDescriptionFailure = createAction(
  'shops/seoDescriptions/deleteShopSeoDescriptionFailure'
)

// Partner Offers
export const fetchPartnerOffers = createAction('shops/fetchPartnerOffers')

export const createPartnerOffer = createAction(
  'shops/partnerOffers/createPartnerOffer'
)
export const createPartnerOfferSuccess = createAction(
  'shops/partnerOffers/createPartnerOfferSuccess'
)
export const createPartnerOfferFailure = createAction(
  'shops/partnerOffers/createPartnerOfferFailure'
)

export const updatePartnerOffer = createAction(
  'shops/partnerOffers/updatePartnerOffer'
)
export const updatePartnerOfferSuccess = createAction(
  'shops/partnerOffers/updatePartnerOfferSuccess'
)
export const updatePartnerOfferFailure = createAction(
  'shops/partnerOffers/updatePartnerOfferFailure'
)

export const deletePartnerOffer = createAction(
  'shops/partnerOffers/deletePartnerOffer'
)
export const deletePartnerOfferSuccess = createAction(
  'shops/partnerOffers/deletePartnerOfferSuccess'
)
export const deletePartnerOfferFailure = createAction(
  'shops/partnerOffers/deletePartnerOfferFailure'
)

// Conquest Ads
export const fetchConquestAds = createAction('shops/fetchConquestAds')

export const createConquestAd = createAction(
  'shops/conquestAds/createConquestAd'
)
export const createConquestAdSuccess = createAction(
  'shops/conquestAds/createConquestAdSuccess'
)
export const createConquestAdFailure = createAction(
  'shops/conquestAds/createConquestAdFailure'
)

export const updateConquestAd = createAction(
  'shops/conquestAds/updateConquestAd'
)
export const updateConquestAdSuccess = createAction(
  'shops/conquestAds/updateConquestAdSuccess'
)
export const updateConquestAdFailure = createAction(
  'shops/conquestAds/updateConquestAdFailure'
)

export const deleteConquestAd = createAction(
  'shops/conquestAds/deleteConquestAd'
)
export const deleteConquestAdSuccess = createAction(
  'shops/conquestAds/deleteConquestAdSuccess'
)
export const deleteConquestAdFailure = createAction(
  'shops/conquestAds/deleteConquestAdFailure'
)
